import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  form: css({
    display: 'grid',
    gridTemplateAreas: `
    "label ."
    "input button"
    "notification notification"
    `,
    columnGap: spacing.default,
    gridTemplateColumns: 'auto min-content',
    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  }),

  label: css({
    gridArea: 'label',
  }),

  input: css({
    gridArea: 'input',
    width: '100%',
    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      marginBottom: spacing.default,
    },
  }),

  submitButton: css({
    gridArea: 'button',
  }),

  notification: css({
    gridArea: 'notification',
    marginTop: spacing.default,
  }),
}

export default styles
